import { render } from "./NerpathamBundleList.vue?vue&type=template&id=56f7ccac&scoped=true"
import script from "./NerpathamBundleList.vue?vue&type=script&lang=js"
export * from "./NerpathamBundleList.vue?vue&type=script&lang=js"

import "./NerpathamBundleList.vue?vue&type=style&index=0&id=56f7ccac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f7ccac"]])

export default __exports__